import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useT, useI18n } from "../i18n/I18nProvider";

/** Contact form state + submit logic (POST /api/contact). */
export function useContactForm() {
  const t = useT();
  const { lang } = useI18n();
  const services = t("contact.services");

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: services[0],
    budget: "",
    timeline: "",
    message: "",
  });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!form.name || !form.email || !form.message) {
      toast.error(t("contact.form.validationError"));
      return;
    }
    setBusy(true);
    try {
      await api.post("/contact", { ...form, lang });
      setSent(true);
      toast.success(t("contact.form.successToast"));
      setForm({ name: "", email: "", subject: services[0], budget: "", timeline: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("contact.form.sendError"));
    } finally {
      setBusy(false);
    }
  };

  return { form, busy, sent, setSent, update, setField, submit, services };
}
